module.exports = __webpack_public_path__ + "static/img/2-07.36d83e2.png";


//////////////////
// WEBPACK FOOTER
// ./static/feige/3/2-07.png
// module id = 224
// module chunks = 0